'use strict';

var $ = require('jquery');
var StateManager = require('../lib/StateManager.js');
var StateHolder = StateManager.StateHolder;
var colorbox = require('../lib/plaudit.colorbox.js');

function isEmpty(obj) {
	for (var prop in obj) {
		if (obj.hasOwnProperty(prop)) {
			return false;
		}
	}
	return true;
}

function Modal(name, opts) {
	StateHolder.call(this, name);

	this.closed = this.closed.bind(this);

	this.defaultOpts = {
		speed: 0,
		fadeOut: 0,
		transition: 'none',
		opacity: .40,
		fixed: true,
		reposition: true,
		width: '90%',
		height: '90%',
		close: '<span class="visuallyHidden">Close</span>',
		onClosed: this.closed
	};
	if (opts !== undefined) {
		if (opts.onClosed !== undefined) {
			var thisRef = this;
			var optsOnClosed = opts.onClosed;
			var defaultOnClosed = this.defaultOpts.onClosed;
			opts.onClosed = function () {
				optsOnClosed(thisRef._skipSaveNextClose);
				defaultOnClosed();
			};
		}
		if (opts.fullscreen === true) {
			this.defaultOpts.width = '100%';
			this.defaultOpts.height = '100%';
			this.defaultOpts.className = 'modal modal--fullscreen';
		}

		this.defaultOpts = $.extend({}, this.defaultOpts, opts);
	}

	StateManager.instance.add(this);
}
Modal.prototype = Object.create(StateHolder.prototype);

Modal.prototype.getStateTitle = function () {
	if (this.state !== undefined && this.state.id !== null) {
		var node = document.getElementById(this.state.id);
		var title = node !== null ? node.getAttribute('data-title') : null;
		if (title !== null && title !== '') {
			return title;
		}
	}
	return null;
}

Modal.prototype.loaded = function (prevState) {
	if (isEmpty(this.state)) {
		// Ensure modal is closed
		if (!isEmpty(prevState)) {
			this._skipSaveNextClose = true;
			$.colorbox.close();
		}
	} else {
		// Open modal
		var opts = $.extend({}, this.defaultOpts, this.state);
		opts = this.preopen(opts);
		if (opts !== false) {
			$.colorbox(opts);
		}
	}
}
/**
 * This method can be overwritten to modify opts right before opening
 *
 * Returning false cancels opening.
 */
Modal.prototype.preopen = function (opts) {
	return opts;
}

Modal.prototype.isOpen = function () {
	return $('#colorbox').css('display') === 'block';
}

Modal.prototype.open = function (opts, save, refresh, url) {
	if (save === undefined)
		save = true;
	if (refresh === undefined)
		refresh = true;

	this.state = opts;

	if (save) {
		StateManager.instance.save(refresh, url);
	}
	/* Needed to target print styling */
	$('html').toggleClass('lightboxOpen', true);
}

Modal.prototype.closed = function () {
	if (this._skipSaveNextClose === true) {
		this._skipSaveNextClose = false;
	} else {
		this.open(undefined, undefined, true);
	}
	/* Needed to target print styling */
	$('html').toggleClass('lightboxOpen', false);
}

module.exports = Modal;